'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var input = require('./input-e08c130c.js');
var styles$a = require('./styles-c1b612d8.js');
var component$b = require('./component-58a86be5.js');

var BookingOverviewPage = function (_a) {
    var status = _a.status, date = _a.date, startDate = _a.startDate, endDate = _a.endDate, formResponses = _a.formResponses, onCancel = _a.onCancel, labels = _a.labels, _b = _a.locale, locale = _b === void 0 ? 'en' : _b, formatDateOption = _a.formatDateOption, timezone = _a.timezone;
    var dateInputValue = date instanceof Date ? date.toLocaleDateString(locale, formatDateOption) : date;
    var startTimeInput = startDate instanceof Date
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ? startDate.toLocaleTimeString(locale, { timeStyle: 'short', timeZone: timezone })
        : startDate;
    var endTimeInput = endDate instanceof Date
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ? endDate.toLocaleTimeString(locale, { timeStyle: 'short', timeZone: timezone })
        : endDate;
    return (React__default.createElement(styles$a.Container, null,
        React__default.createElement(styles$a.DoublePane, null,
            React__default.createElement(styles$a.DescriptionWrapper, null,
                React__default.createElement(component$b.TitleBlock, { title: labels.bookingOverviewTitle, subtitle: labels.bookingOverviewSubtitle })),
            React__default.createElement(styles$a.ResponsesWrapper, null,
                React__default.createElement(styles$a.StatusText, null,
                    labels.status,
                    ":",
                    ' ',
                    labels[status]),
                React__default.createElement(styles$a.RightPane, null,
                    React__default.createElement(styles$a.DateInput, { disabled: true, label: labels.date, value: dateInputValue }),
                    React__default.createElement(styles$a.StartTimeInput, { disabled: true, label: labels.startTime, value: startTimeInput }),
                    React__default.createElement(styles$a.EndTimeInput, { disabled: true, label: labels.endTime, value: endTimeInput })),
                React__default.createElement(styles$a.FormResponsesWrapper, null,
                    React__default.createElement(styles$a.FormResponses, null, formResponses.map(function (q) { return (React__default.createElement(input.Input, { key: q.question, disabled: true, value: q.answer, type: "text", label: q.question })); }))))),
        React__default.createElement(styles$a.CancelRequestButtonWrapper, null,
            React__default.createElement(styles$a.CancelRequestButton, { "data-testid": "cancel-button", text: labels.cancelRequest, variant: "secondary", onClick: onCancel }))));
};

exports.BookingOverviewPage = BookingOverviewPage;
